import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { UntypedFormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { LogoutStateHandlerService } from 'src/app/services/logout-state-handler.service';
import { ProfileImageService } from 'src/app/services/profile-image.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { environment } from 'environment';
import { MessageService } from 'primeng/api';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  hidePassword = true;
  loginForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
    password: ['', Validators.required],
    recaptcha: ['', Validators.required],
    otp: ['', Validators.required]
  });
  value: any

  token: string | undefined;
  message: string | undefined;
  newBrowser = false
  resLoader = false
  sectionFalg = 'login'
  siteKey: string = environment.recaptchaSiteKey
  externalUser = false;
  /** An external user whose role is trainer — see {@link goToTrainerPortal}. */
  externalTrainer = false;
  importedUser = false;
  blockAccount = false
  importedUserData: any;
  translator: TranslatorPipe = new TranslatorPipe();
  loading: boolean = false;


  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private permissionService: PermissionHandlerService,
    private loginStateHandler: LogoutStateHandlerService,
    private profileService: ProfileImageService,
    private messageService: MessageService,
    private themeService: ThemeService
  ) {

  }

  ngOnInit(): void {
    // Logout clears localStorage without reloading, so fetch the default again:
    // it also replaces the previous user's OU colours still on :root.
    this.themeService.init();
  }


  onOtpChange(data: any) {
    if (data.length == 4) {
      this.loginForm.get('otp')?.setValue(data)
    }
  }

  translate(value: string) {
    return this.translator.transform(value);
  }

  async onSubmit() {
    try {

      for (const control of Object.keys(this.loginForm.controls)) {
        if (control != 'otp' && !this.loginForm.controls[control].valid) {
          this.loginForm.controls[control].markAsTouched();
          return;
        }
      }

      this.loading = true;

      this.blockAccount = false

      let data = this.loginForm.value
      data.email = data?.email?.trim()

      if (!this.newBrowser) {
        delete data.otp
      }

      delete data.recaptcha

      let response = await this.dataService.postData("user/login", data)
      this.loading = false;

      if (response.msg == 'Due to multiple invalid Password reasons account blocked') {
        this.message = 'تم إيقاف حسابك مؤقتًا بسبب المحاولات الخاطئة المتكرّرة لتسجيل الدخول، يرجى الضغط هنا لاستلام رسالة التفعيل على بريدك الإلكتروني'
        this.resLoader = false
        this.blockAccount = true
        return

      }


      if (response.msg === "User not activated, please contact administrator") {
        this.message = response.msg;
        this.resLoader = false
        return
      }

      //handling new browser request
      if (response.msg == 'New Browser Detected') {
        this.newBrowser = true
        this.resLoader = false
        this.message = 'قمت بتسجيل الدخول من متصفح جديد، يرجى تفقد بريدك الإلكتروني لكلمة المرور الصالحة لمرة واحدة'
        return
      }

      if (!response.error || response.msg === "Login Sucessfully") {

        this.resLoader = false

        console.log("login response==>", response.data)
        
        
        let { accessToken, username, role, email, national_id, phone, gender, resetPassword, id, ministries, image, managerOus, externalUser, isVendor, vendorExtraDetails, ou, location: userLocation, master_trainer, createdAt, favoriteData, theme, permissionRequests, isTester , themeDefault, branchTrainer } = response.data

       
        localStorage.setItem('isLoggedIn', "true");
        localStorage.setItem('token', accessToken);
        localStorage.setItem('username', `${username.first} ${username.middle} ${username.last}`);
        localStorage.setItem('role', JSON.stringify(role));
        localStorage.setItem('email', email);
        localStorage.setItem('national_id', national_id);
        localStorage.setItem('phone', phone);
        localStorage.setItem('gender', gender);
        localStorage.setItem('uid', id);
        localStorage.setItem('userMinistry', JSON.stringify(ministries));
        localStorage.setItem('managerOus', JSON.stringify(managerOus));
        localStorage.setItem('image', image);
        localStorage.setItem('externalUser', JSON.stringify(externalUser));
        localStorage.setItem('isVendor', isVendor)
        localStorage.setItem('type', vendorExtraDetails?.classification ?? 'internal')
        localStorage.setItem('ou', JSON.stringify(ou))
        localStorage.setItem('master_trainer', master_trainer)
        localStorage.setItem('createdAt', createdAt)
        localStorage.setItem('JustLoggedIn', 'Yes')
        localStorage.setItem('theme',JSON.stringify(theme));
        localStorage.setItem('permissionRequests',JSON.stringify(permissionRequests));
        if(!!favoriteData) localStorage.setItem('favoriteData', JSON.stringify(favoriteData));
        localStorage.setItem('isTester',isTester);
        localStorage.setItem('themeDefault',JSON.stringify(themeDefault));
        // app.component only applies the theme on a full page load, so without
        // this the colours from before login would stay until the next refresh.
        this.themeService.applyStored();
        localStorage.setItem('branchTrainer',JSON.stringify(branchTrainer));
        this.profileService.setImage(image);
        this.loading = true;
        try {
          await this.permissionService.init();
        } finally {
          this.loading = false;
        }

        if (resetPassword.status == true) {
          if (externalUser?.status == true && (externalUser?.role == 'Coordinator' || externalUser?.role == 'trainer')) {
            this.externalUser = true
            // Kept apart from `externalUser`: the two land in different places
            // once the password is set. See `goToTrainerPortal`.
            this.externalTrainer = externalUser?.role == 'trainer'
          }
          this.sectionFalg = 'resetPassword'
          this.message = undefined
        } else {
          // const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
          // this.router.navigateByUrl(returnUrl);

          console.log("===> Cordinator view,", externalUser)

          // An external trainer's work is the sessions they deliver, and those
          // now live in the Tayseer portal rather than here. Coordinators stay
          // on /coordinator-view: theirs is managing their company's trainers,
          // which is still a KGate screen.
          if (externalUser?.status == true && externalUser?.role == 'trainer') {
            this.goToTrainerPortal();
          } else if (externalUser?.status == true && externalUser?.role == 'Coordinator') {
            this.router.navigate(["/coordinator-view"]);
          } else if (externalUser.imported == true) {
            console.log("Imported user");
            this.importedUser = true;

            let now = new Date();

            this.importedUserData = {
              name: username,
              email: email,
              phone: phone,
              national_id: national_id,
              gender: gender,
              role: role,
              location: userLocation,
              ou,
              _id: id,
              active: {
                status: true,
                activationCode: "",
                reason: null,
                activationDate: now.toLocaleString()
              }
            };
          }
          else this.router.navigate(["/home"], { queryParams: { reload: new Date().getTime() } });
        }


      } else {
        this.message = JSON.stringify(response.msg);

      }

      if (this.loginStateHandler.loginStateUrl) {
        let url = this.loginStateHandler.loginStateUrl;
        this.loginStateHandler.loginStateUrl = null;
        this.router.navigate([url])
      }

      console.log('MSGI', this.message);
      console.log(typeof this.message);

    } catch (error) {
      console.log(error)
    }
  }

  

  //forgot Password
  forgotForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],

  });

  async forgotPasword() {
    try {
      let data = this.forgotForm.value;
      data.email = data.email.toLowerCase();
      this.resLoader = true
      const res = await this.dataService.postData('user/forgot-password', data)
      if (!res.error) {
        this.resLoader = false
        this.message = res.msg
        this.sectionFalg = 'login'
      } else {
        this.message = res.msg
        this.resLoader = false

      }
    } catch (error) {
      //console.log(error)
    }
  }


  //Reset Password On First Login
  submitted = false;
  password1 = '';
  password2 = '';
  resetPasswordForm = this.formBuilder.group({
    password: ['', Validators.required, Validators.min(8)],
    conformPassword: ['', Validators.required, Validators.min(8)],
  });
  hide = true;
  hide2 = true;

  get f() { return this.resetPasswordForm?.controls; }



  /**
   * Sends an external trainer to their sessions in the Tayseer portal.
   *
   * A plain location change, not a router navigation: the portal is a separate
   * Angular app served same-origin under /training, so this app's router cannot
   * reach it and would resolve the path against its own routes instead. It is
   * the delivery view for the same reason KGate's user profile links there —
   * that is where a trainer's assignments are, and only Tayseer knows whether
   * they are continuous or onboarding ones.
   *
   * replace(), not href: the login page has nothing to go back to, and leaving
   * it in history bounces the user forward again on Back.
   */
  private goToTrainerPortal() {
    window.location.replace('/training/continuous?view=delivery');
  }

  resetPassword = async () => {
    try {
      const data = {
        password: this.f?.['password'].value,
        conformPassword: this.f?.['conformPassword'].value
      }

      var allowpassword = this.checkpassword() && this.atleast8() && this.atleastcapital() && this.atleastnumber() && this.atleastsmall() && this.atleastspecial();

      if (!allowpassword) this.message = "Password requirements not met"
      else {
        const res = await this.dataService.postData('user/update-password', { password: data.password }, 'PUT', false)
        if (!res.error) {
          this.message = res.msg
          if (this.externalTrainer) {
            this.goToTrainerPortal();
          } else if (this.externalUser) {
            this.router.navigate(["/coordinator-view"]);
          } else this.router.navigate(["/home"]);
        } else {
          this.message = res.msg
        }
      }
    } catch (error) {
      //console.log(error) 
    }
  }

  async resendEmail() {
    try {
      let data = this.loginForm.value
      let res: any = this.dataService.postData('user/activate-account-mail/' + data.email, {}, 'PUT')
      if (res.error) {
        return
      }

      this.message = "Mail Send SuccessFully"


    } catch (error) {

    }
  }


  checkpassword() {

    var password = this.f?.['password'].value;
    var conformPassword = this.f?.['conformPassword'].value;

    if (password == conformPassword) {
      return true;
    } else {
      return false;
    }
  }

  atleast8() {
    var password = this.f?.['password'].value;
    if (password.length > 7) {
      return true;
    } else {
      return false;
    }
  }

  atleastcapital() {
    var password = this.f?.['password'].value;
    return /[A-Z]/.test(password);
  }

  atleastsmall() {
    var password = this.f?.['password'].value;
    return /[a-z]/.test(password);
  }

  atleastnumber() {
    var password = this.f?.['password'].value;
    return /[0-9]/.test(password);
  }

  atleastspecial() {
    var password = this.f?.['password'].value;

    return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
  }

  //resend mail start count

  allowSendMail: any = true
  countdown: number = 60; // Countdown timer in seconds
  interval: any; // Variable to store the interval

  startCountdown() {
    this.allowSendMail = false
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.allowSendMail = true;
        clearInterval(this.interval);
      }
    }, 1000); // Update every second
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  trimPasswordField(fieldName: string) {
    let form: FormGroup | null = null;
    
    if (this.sectionFalg === 'login') {
      form = this.loginForm;
    } else if (this.sectionFalg === 'resetPassword') {
      form = this.resetPasswordForm;
    }
    
    if (form) {
      const field = form.get(fieldName);
      if (field && field.value) {
        const trimmedValue = field.value.trim();
        field.setValue(trimmedValue);
      }
    }
  }

  



}